export const routeNames = {
  LOGIN: '/login',
  ADMIN: '/admin'
}
